var _path, _rect, _g, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9EB",
    d: "M0 0h20v20H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7458,
    y: -6594,
    width: 11379,
    height: 8219,
    rx: 40,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pause_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-28-208c0-15.464 12.536-28 28-28h404c15.464 0 28 12.536 28 28V20c0 15.464-12.536 28-28 28H0c-15.464 0-28-12.536-28-28v-228Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FCE0D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 6,
    width: 8,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(90 13.5 6)",
    fill: "#F26526"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 8,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(90 8 6)",
    fill: "#F26526"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -47.5,
    y: -927.5,
    width: 759,
    height: 1179,
    rx: 4.5,
    stroke: "#7B61FF",
    strokeDasharray: "10 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pause_svg__a",
    x: -78,
    y: -266,
    width: 560,
    height: 384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.286275 0 0 0 0 0.345098 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_0",
    result: "shape"
  })))));
};

export default SvgPause;